import { initiatePriorityPatientWorker } from './initiatePriorityPatientWorker'

export const loadPriorityPatient = async () => {
  const monitorsStore = useMonitorsStore()
  const devicesStore: any = useDevicesStore()
  const priorityPatientStore: any = usePriorityPatientsStore()
  initiatePriorityPatientWorker()
  if (priorityPatientStore.isLoaded) return null

  try {
    await monitorsStore.load()
  } catch (error) {
    console.error(error, 'Monitor Fails!')
  }

  try {
    await devicesStore.load()
  } catch (error) {
    console.error(error, 'Devices Fails!')
  }
  try {
    await priorityPatientStore.load({ episodeOfCareStatuses: ['planned', 'active'], showAllPatients: true })
  } catch (error) {
    console.error(error, 'PriorityPatient Fails!')
  }
}
